import { useState } from "react"
import { IconCopy, IconCheck, IconEye, IconEyeOff } from "@tabler/icons-react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

interface ApiTokenDisplayProps {
  token: string
}

export function ApiTokenDisplay({ token }: ApiTokenDisplayProps) {
  const [copied, setCopied] = useState(false)
  const [visible, setVisible] = useState(false)

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(token)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
      <Input
        type={visible ? "text" : "password"}
        value={token}
        readOnly
        className="font-mono text-sm sm:flex-1"
      />
      <div className="flex items-center gap-2 self-end sm:self-auto">
        <Button
          variant="outline"
          size="icon-touch"
          onClick={() => setVisible(!visible)}
          title={visible ? "Hide token" : "Show token"}
        >
          {visible ? <IconEyeOff className="size-4" /> : <IconEye className="size-4" />}
        </Button>
        <Button
          variant="outline"
          size="icon-touch"
          onClick={copyToClipboard}
          title="Copy to clipboard"
        >
          {copied ? (
            <IconCheck className="size-4 text-green-500" />
          ) : (
            <IconCopy className="size-4" />
          )}
        </Button>
      </div>
    </div>
  )
}
